<template>
    <div class="main-layout" :class="{ 'article-layout': flowType === 'Article' }">
        <div class="main-container">
            <div class="source-container">
                <p class="title">Generate {{ flowType }}</p>

                <div class="selected-document">
                    <p class="label">
                        Source Document<span class="required">*</span>
                        <img :src="require('@/assets/icons/info-outline.svg')" alt="Info" />
                    </p>

                    <div class="select-wrapper">
                        <div class="input-wrapper">
                            <v-select class="input" :items="sourceList" density="compact" item-title="documentName"
                                item-value="documentType" variant="outlined" bg-color="#FFFFFF33" :disabled="disabled"

                                v-model="selectedSource" :rules="selectRules" placeholder="Select document type" />
                        </div>
                        <div class="input-wrapper">
                            <v-autocomplete class="input" :items="documentList" density="compact" :item-title="titleKey"
                                :item-value="valueKey" placeholder="Search by PR, narratives, key messages"
                                variant="outlined" bg-color="#FFFFFF33" v-model="selectedDocumentId"
                                :rules="selectRules" :disabled="isSelectDocumentDisabled || disabled"

                                prepend-inner-icon="mdi-magnify" :loading="loader">
                                <template v-if="selectedDocumentId" #append-inner>
                                    <v-icon v-if="!disabled" icon="mdi-close" class="cursor-pointer"

                                        @click.stop="selectedDocumentId = null" />
                                </template>
                            </v-autocomplete>
                        </div>
                    </div>
                </div>
            </div>

            <div class="selected-doc-container" v-if="selectedSource && selectedDocumentId" @mouseup="checkSelection">
                <p class="selected-doc-txt">Selected Document</p>
                <div class="selected-doc-wrapper">
                    <div v-if="documentLoader" class="loader-wrapper">
                        <v-progress-circular indeterminate :size="40" color="#FFFFFF" :width="5" />
                    </div>
                    <div v-else class="document-wrapper" :key="refresh" v-html="selectedDocument" />
                </div>
            </div>
        </div>

        <div v-if="flowType === 'Article'" class="right-empty-panel">

            <div class="header">
                <div class="key-title">
                    <Svg :src="require('@/assets/icons/focus.svg')" alt="create" height="20px" width="20px"></Svg>
                    Key Text to Focus
                    <span class="required">*</span>
                </div>

            </div>
            <div class="wrapper">
                <textarea class="custom-native-textarea" v-model="selectedSection"
                    :disabled="selectedSection !== '' || disabled"
                    placeholder="Select a section from the selected document that should guide the output"
                    @input="autoResizeTextarea"></textarea>

            </div>

        </div>
    </div>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />

</template>



<script>
import axiosInstance from '@/axiosInterceptor'
import CommonPopup from './CommonPopup.vue';
export default {

    name: 'SourceDocument',
    components: {
        CommonPopup
    },
    props: {
        sourceList: {
            type: Array,
            default: []
        },
        flowType: {
            type: String,
        },
        documentType: {
            type: String
        },
        documentId: {
            type: String
        },
        sectionContent: {
            type: String
        },
        disabled: {
            type: Boolean
        }
    },

    data() {
        return {
            documentList: [],
            titleKey: '',
            valueKey: '',
            selectedSection: '',
            loader: false,
            isSelectDocumentDisabled: true,
            documentLoader: false,
            selectedDocumentId: null,
            initializingFromProps: false,
            selectedDocument: null,
            refresh: 0,
            selectedSource: null,
            selectRules: [
                v => !!v || 'This field is required'
            ],
        }
    },

    watch: {
        selectedSource: {
            handler(newValue) {
                if (newValue || newValue !== '' || newValue !== undefined) {
                    this.isSelectDocumentDisabled = true;
                    if (!this.initializingFromProps) {
                        this.selectedDocumentId = null;
                    }
                    this.emitSelectedDocumentMeta();
                    this.handleFetchFunction(newValue);
                    this.initializingFromProps = false;
                }
            },
            deep: true
        },
        selectedSection: {
            handler(newValue) {
                if (newValue || newValue !== '' || newValue !== undefined) {
                    this.emitSelectedDocumentMeta()
                }
            },
        },

        selectedDocumentId: {
            handler(newValue) {
                if (!newValue) {
                    this.selectedDocument = null;
                    return;
                }

                this.emitSelectedDocumentMeta()
                this.fetchDocumentDetails(newValue);

            },
            deep: true

        }
    },

    computed: {

    },

    methods: {
        handlePopupConfirmation(action) {
            if (action === 'yes') {
                this.selectedSection = this.pendingSelectionText;
            }
            this.pendingSelectionText = null;
            this.showCommonPopup = false;
        },

        checkSelection() {
            const selection = window.getSelection();
            const text = selection.toString().trim();

            this.selectedSection = text;
        },

        confirmReplace() {
            this.selectedSection = this.pendingSelectionText;
            this.pendingSelectionText = null;
            this.showConfirmPopup = false;
        },

        cancelReplace() {
            this.pendingSelectionText = null;
            this.showConfirmPopup = false;
        },

        autoResizeTextarea(event) {
            const textarea = event.target;
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
            this.selectedSection = textarea.value;
        },
        emitSelectedDocumentMeta() {
            if (this.selectedSource && this.selectedDocumentId && this.selectedDocument) {
                this.$emit('document-meta-selected', {
                    sourceType: this.selectedSource,
                    documentId: this.selectedDocumentId,
                    selectedDocument: this.selectedDocument,
                    selectedSection: this.selectedSection
                });
            }
        },
        async handleFetchFunction(docType) {
            this.loader = true;

            if (docType === 'BUISNESS_NARRATVE') {
                this.titleKey = 'narrativeName';
                this.valueKey = 'narrativeId';
                const response = await axiosInstance.get('/narrative?status=COMPLETED');
                this.loader = false;
                this.isSelectDocumentDisabled = false
                this.documentList = response.data.data;
            }
            else if (docType === 'PR') {
                const response = await axiosInstance.get('/pr?status=COMPLETED');
                this.titleKey = 'prName';
                this.valueKey = 'prId';
                this.loader = false;
                this.isSelectDocumentDisabled = false
                this.documentList = response.data.data;
            }
            else if (docType === 'ARTICLE') {
                const response = await axiosInstance.get('/article?status=COMPLETED');
                this.titleKey = 'articleDocumentName';
                this.valueKey = 'articleId';
                this.loader = false;
                this.isSelectDocumentDisabled = false
                this.selectedDocumentId = null;
                this.documentList = response.data.data;
            }
            else {
                const response = await axiosInstance.get('/messageHouse');
                this.titleKey = 'title';
                this.valueKey = 'msgHouseId';
                this.loader = false;
                this.isSelectDocumentDisabled = false
                this.documentList = response.data.data;
                this.documentList = this.documentList.filter(
                    (item) => item.status === "COMPLETED"
                );
            }
        },

        async fetchDocumentDetails(documentId) {
            this.documentLoader = true;
            try {
                let endpoint;
                if (this.selectedSource === 'BUISNESS_NARRATVE') {
                    endpoint = `/narrative/${documentId}`;
                } else if (this.selectedSource === 'PR') {
                    endpoint = `/pr/${documentId}`;
                } else if (this.selectedSource === 'ARTICLE') {
                    endpoint = `/article/${documentId}`;
                } else {
                    endpoint = `/messageHouse/${documentId}`;
                }

                const response = await axiosInstance.get(endpoint);
                switch (this.selectedSource) {
                    case 'PR':
                        const prContent = response.data.data.finalizedPr;
                        this.selectedDocument = `<h2>${prContent.prTitle}</h2>${prContent.prContent}` || "No PR content found.";
                        break;
                    case 'BUISNESS_NARRATVE':
                        const generatedContent = response.data.data.finalizedNarrative;
                        this.selectedDocument = generatedContent.narrativeData;

                        break;
                    case 'ARTICLE':
                        const articleContent = response.data.data.articleContent;
                        if (!articleContent || !articleContent.baseArticle) {
                            this.selectedDocument = "No article content found.";
                        } else {
                            const articleTitle = articleContent.articleDocumentName || "";
                            this.selectedDocument = `<h2>${articleTitle}</h2>${articleContent.baseArticle}`;
                        }
                        break;
                    case 'MESSAGE_HOUSE':
                        // Adjust based on your API response structure
                        const baseMsgHouse = response.data.data?.baseMsgHouse;

                        if (!baseMsgHouse) {
                            this.selectedDocument = "No message house content found.";
                        } else {
                            this.selectedDocument = baseMsgHouse;
                        }
                        break;
                    default:
                        this.selectedDocument = "Invalid document type.";

                }
                this.documentLoader = false;
                this.refresh += 1;
            } catch (error) {
                console.error("Error fetching document:", error);
                this.selectedDocument = "Failed to load document.";
            } finally {
                this.documentLoader = false;
                this.emitSelectedDocumentMeta();
            }
        }

    },

    mounted() {
        if (this.documentType && this.documentId || this.sectionContent) {
            this.initializingFromProps = true;
            this.selectedSource = this.documentType;
            this.selectedDocumentId = this.documentId;
            this.selectedSection = this.sectionContent
        }

    }
}
</script>

<style scoped>
.main-layout {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 2rem;
}

.main-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    height: 100%;
    color: #ffffff;
    padding: 2rem 15%;
    box-sizing: border-box;
    min-height: 0;
}

.article-layout .main-container {
    display: flex;
    flex: 2;
    padding: 2rem;
}

.header {
    border-bottom: 1px solid #e0e0e0;
    padding: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.right-empty-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #ffffff;
    border-radius: 12px;
    height: 100%;
    overflow: hidden;
}

.wrapper {
    padding: 1rem;
    flex: 1;
    display: flex;
    min-height: 0;
}

.custom-native-textarea {
    width: 100%;
    min-height: 40px;
    max-height: 400px;
    padding: 8px;
    border: 1px solid #D4D4D4;
    border-radius: 12px;
    resize: none;
    overflow-y: auto;
    scrollbar-width: thin;
    font-size: 14px;
    font-style: italic;
}

.custom-native-textarea:focus {
    outline: none;
}


.key-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    gap: 4px;
    color: var(--primary-font-color);
    font-weight: 600;
    font-size: var(--normal-font-size);

}

.required {
    color: red
}

.main-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    height: 100%;
    color: #FFFFFF;
    padding: 2rem 15%;
    box-sizing: border-box;
    min-height: 0;
}

.source-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.title {
    color: #FFFFFF;
    font-size: var(--header-font-size);
    font-weight: 600;
}

.selected-document {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.label {
    display: flex;
    color: var(--secondary-font-color);
    align-items: center;
    gap: 4px;
    font-size: var(--normal-font-size);
}

.select-wrapper {
    display: flex;
    gap: 1rem;
}

.input-wrapper {
    display: flex;
    width: 50%;
}

.input-wrapper:first-child {
    flex: 1;
}

.input-wrapper:last-child {
    flex: 1.5;
}

.selected-doc-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: hidden;
}

.selected-doc-txt {
    font-size: var(--normal-font-size);
    text-align: left;
    color: #FFFFFF99;
    font-style: italic;
}

.selected-doc-wrapper {
    display: flex;
    justify-content: center;
    background: #FFFFFF0A;
    border: 1px solid hsla(0, 0%, 100%, 0.2);
    border-radius: 12px;
    overflow: hidden;
}

.loader-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.document-wrapper {
    width: 100%;
    padding: 1.2rem;
    height: 100%;
    scrollbar-width: thin;
    will-change: transform;
    overflow: auto;
    background: #FFFFFF;
    border-radius: 12px;
    color: black;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.document-wrapper :deep(::selection) {
    background: #FF780029;
}
</style>